import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import IsAuth from "../../utillityComponents/IsAuth";
import LoadingSpinner from "../../utillityComponents/LoadingSpinner";
import ModalSuccess from "../../utillityComponents/ModalSuccess";

export default function ProfileForm() {
    const axiosPrivate = useAxiosPrivate();
    const { auth, setUserData, userData } = useAuth();
    const { user_id } = useParams();
    let navigate = useNavigate();
  
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [city, setCity] = useState('');
    const [photoFile, setPhotoFile] = useState(null);
    const [email, setEmail] = useState('');
    const [allRoles, setAllRoles] = useState([]);
    const [password, setPassword] = useState('');
    const [verifyPassword, setVerifyPassword] = useState('');
    const [pwError, setPwError] = useState('');
    const [modelSave, setModelSave] = useState(false);
    const [notification, setNotification] = useState('');
    const [editData, setEditData] = useState('');
    const [loaded, setLoades] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [imgPreview, setImgPreview] = useState('');

    const userId = user_id? user_id : auth.id;

    const handleChange = (file) => {
        setPhotoFile(file[0])
        if (file && file[0]) {
            // Cleanup previous URL to prevent memory leaks
            if (imgPreview && imgPreview.startsWith('blob:')) {
                URL.revokeObjectURL(imgPreview);
            }
            const url = URL.createObjectURL(file[0]);
            setImgPreview(url);
        }
    }

    const uploadAxios = axios.create({
      headers: {
          Authorization: 'Bearer ' + localStorage.getItem('aT'),
          'Content-Type': 'multipart/form-data',
      },
    });

    const saveComplete = async () => {
      setModelSave(true)
      setTimeout(() => {
        setModelSave(false)
      }, 2000);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        let isMounted = true;
        const controller = new AbortController();
        const formData = new FormData();
        
        formData.append("is_activated", isActive);

        if (firstName !== null) {
          formData.append("firstName", firstName);
        }
  
        if (lastName !== null) {
          formData.append("lastName", lastName);
        }

        if (city !== null) {
          formData.append("city", city);
        }
  
        if (email !== null) {
          formData.append("email", email);
        }
    
        if (photoFile !== null) {
          formData.append("img", photoFile);
        }

        if (password !== verifyPassword) {
            setPwError('Koderne er ikke ens')
            return;
        }

        if (password.length !== 0 && password.length < 8) {
          setPwError('Koderne er for kort - min 8 tegn')
          return;
        }

        if (password.length !== 0) {
          formData.append("password", password);
        }

        setIsSaving(true);

        const saveEdit = async () => {
           try {
                const response = await uploadAxios.post(process.env.REACT_APP_API_BASEURL + '/user/edit/' + userId, formData
                );
                const profil_img = response?.data?.user_profile_image ? process.env.REACT_APP_CLUDFLARE_IMG_BASE_URL + response?.data?.user_profile_image : process.env.REACT_APP_CLUDFLARE_DEFAULT_IMG_URL;
                const roles = response?.data?.roles;
                const name = response?.data?.user_display_name;
                const id = response?.data?.id;
                const email = response?.data?.user_email;
                const first_name = response?.data?.user_first_name;
                const last_name = response?.data?.user_last_name;
                const city = response?.data?.user_city;
                isMounted  && saveComplete()
                if (userId == auth.id) {
                  setUserData({ profil_img, email, id, roles, name, first_name, last_name, city })
                }
                setEditData({ profil_img, email, id, roles, name, first_name, last_name, city })
                setPwError('') 
            } catch (err) {
                console.error(err);
                console.log(photoFile);
            }  finally {
                setIsSaving(false);
            }
        }

        saveEdit();

        return () => {
            isMounted = false;
            controller.abort();
            setPwError('')
        }
    }

    const getUserData = async () => {
      let isMounted = true;
      const controller = new AbortController();

      try {
          const response = await axiosPrivate.get('/user/get/' + userId, {
              signal: controller.signal
          });
          const profil_img = response?.data?.user_profile_image ? process.env.REACT_APP_CLUDFLARE_IMG_BASE_URL + response?.data?.user_profile_image : process.env.REACT_APP_CLUDFLARE_DEFAULT_IMG_URL;
          const roles = response?.data?.roles;
          const name = response?.data?.user_display_name;
          const id = response?.data?.id;
          const email = response?.data?.user_email;
          const first_name = response?.data?.user_first_name;
          const last_name = response?.data?.user_last_name;
          const city = response?.data?.user_city;
          const isActivated = response?.data?.is_user_activated;
          isMounted && setEditData({ profil_img, email, id, roles, name, first_name, last_name, city })
          setIsActive(isActivated)
          setImgPreview(profil_img)
          setLoades(true)
      } catch (err) {
         console.log(err?.response)
      }               

      return () => {
          isMounted = false;
          controller.abort();
      }
    }

    const setRoles = (role, checked) => {
      // TODO: Implement role management logic
      console.log('Role:', role, 'Checked:', checked);
    } 

    useEffect(() => {
      getUserData()
      
      // Cleanup function to revoke object URLs
      return () => {
        if (imgPreview && imgPreview.startsWith('blob:')) {
          URL.revokeObjectURL(imgPreview);
        }
      }
    },[])

    useEffect(() => {
      setFirstName(editData.first_name)
      setLastName(editData.last_name)
      setCity(editData.city)
      setEmail(editData.email)
    },[editData])

    /* window.Echo.channel("User").listen(".Notifications", (event) => {
      setNotification(event.notification);
      console.log(event);
    }); */

    return (
      <>
      {loaded? <>
      <ModalSuccess show={modelSave}/> 
        <div className="min-h-screen py-8 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            {/* Header Section */}
            <div className="mb-8">
              <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
                <div className="bg-primary-blue px-8 py-6">
                  <div className="flex items-center space-x-4">
                    <div className="relative">
                      <div className="h-20 w-20 rounded-full ring-4 ring-white/20 overflow-hidden bg-white/10 backdrop-blur-sm">
                        <img
                          className="h-full w-full object-cover"
                          src={(imgPreview || editData.profil_img) + "/36x36"}
                          alt={editData.name}
                        />
                      </div>
                      {photoFile && (
                        <div className="absolute -bottom-1 -right-1 h-6 w-6 bg-green-500 rounded-full flex items-center justify-center ring-2 ring-white">
                          <svg className="h-3 w-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="flex-1">
                      <h1 className="text-2xl font-bold text-white">{editData.name}</h1>
                      <p className="text-indigo-100 mt-1">{editData.email}</p>
                      <div className="flex items-center mt-2">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                          isActive 
                            ? 'bg-green-100 text-green-800' 
                            : 'bg-red-100 text-red-800'
                        }`}>
                          <div className={`w-2 h-2 rounded-full mr-1.5 ${
                            isActive ? 'bg-green-400' : 'bg-red-400'
                          }`}></div>
                          {isActive ? 'Aktiv' : 'Deaktiveret'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Profile Information Card */}
              <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
                <div className="px-8 py-6 border-b border-gray-100">
                  <h2 className="text-xl font-semibold text-gray-900 flex items-center">
                    <svg className="w-5 h-5 mr-2 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                    Profil Information
                  </h2>
                  <p className="text-gray-500 text-sm mt-1">Opdater dine personlige oplysninger</p>
                </div>
  
                <div className="px-8 py-6 space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-2">
                      <label htmlFor="first-name" className="block text-sm font-semibold text-gray-700">
                        Fornavn
                      </label>
                      <input
                        type="text"
                        name="first-name"
                        id="first-name"
                        onChange={(e) => setFirstName(e.target.value)}
                        value={firstName ?? ''}
                        autoComplete="given-name"
                        className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200 bg-gray-50 focus:bg-white"
                        placeholder="Indtast dit fornavn"
                      />
                    </div>

                    <div className="space-y-2">
                      <label htmlFor="last-name" className="block text-sm font-semibold text-gray-700">
                        Efternavn
                      </label>
                      <input
                        type="text"
                        name="last-name"
                        id="last-name"
                        onChange={(e) => setLastName(e.target.value)}
                        value={lastName ?? ''}
                        autoComplete="family-name"
                        className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200 bg-gray-50 focus:bg-white"
                        placeholder="Indtast dit efternavn"
                      />
                    </div>

                    <div className="space-y-2">
                      <label htmlFor="email" className="block text-sm font-semibold text-gray-700">
                        Email adresse
                      </label>
                      <input
                        id="email"
                        name="email"
                        type="email"
                        onChange={(e) => setEmail(e.target.value)}
                        value={email ?? ''}
                        autoComplete="email"
                        className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200 bg-gray-50 focus:bg-white"
                        placeholder="din@email.dk"
                      />
                    </div>

                    <div className="space-y-2">
                      <label htmlFor="city" className="block text-sm font-semibold text-gray-700">
                        By
                      </label>
                      <input
                        type="text"
                        name="city"
                        id="city"
                        onChange={(e) => setCity(e.target.value)}
                        value={city ?? ''}
                        className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200 bg-gray-50 focus:bg-white"
                        placeholder="Din by"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Profile Image Card */}
              <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
                <div className="px-8 py-6 border-b border-gray-100">
                  <h2 className="text-xl font-semibold text-gray-900 flex items-center">
                    <svg className="w-5 h-5 mr-2 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    Profilbillede
                  </h2>
                  <p className="text-gray-500 text-sm mt-1">Upload et nyt profilbillede</p>
                </div>
                <div className="px-8 py-6">
                  <div className="flex items-center space-x-6">
                    <div className="relative">
                      <div className="h-24 w-24 rounded-2xl ring-4 ring-gray-100 overflow-hidden bg-gray-50">
                        <img
                          className="h-full w-full object-cover"
                          src={(imgPreview || editData.profil_img) + "/36x36"}
                          alt={editData.name}
                        />
                      </div>
                      {photoFile && (
                        <div className="absolute -bottom-2 -right-2 h-7 w-7 bg-green-500 rounded-full flex items-center justify-center ring-2 ring-white shadow-lg">
                          <svg className="h-4 w-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="flex-1">
                      <input  
                        name="image"
                        id="image"
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleChange(e.target.files)}
                        className="block w-full text-sm text-gray-500 file:mr-4 file:py-3 file:px-6 file:rounded-xl file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-200"
                      />
                      <p className="mt-2 text-xs text-gray-500">PNG, JPG, GIF op til 10MB</p>
                    </div>
                  </div>
                </div>
              </div>


              {/* Security Card */}
              <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
                <div className="px-8 py-6 border-b border-gray-100">
                  <h2 className="text-xl font-semibold text-gray-900 flex items-center">
                    <svg className="w-5 h-5 mr-2 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                    Sikkerhed
                  </h2>
                  <p className="text-gray-500 text-sm mt-1">Opdater din adgangskode</p>
                </div>
                <div className="px-8 py-6 space-y-6">
                  <div className="space-y-2">
                    <label htmlFor="password" className="block text-sm font-semibold text-gray-700">
                      Ny adgangskode
                    </label>
                    <input
                      type="password"
                      name="password"
                      id="password"
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                      placeholder="Efterlad tom for at beholde nuværende kode"
                      className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200 bg-gray-50 focus:bg-white"
                    />
                    {password.length > 0 && password.length < 8 && (
                      <p className="text-xs text-red-500 flex items-center mt-1">
                        <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        Minimum 8 tegn påkrævet
                      </p>
                    )}
                  </div>

                  {password.length > 0 && (
                    <div className="space-y-2">
                      <label htmlFor="verify_password" className="block text-sm font-semibold text-gray-700">
                        Bekræft adgangskode
                      </label>
                      <input
                        type="password"
                        name="verify_password"
                        id="verify_password"
                        onChange={(e) => setVerifyPassword(e.target.value)}
                        value={verifyPassword}
                        className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200 bg-gray-50 focus:bg-white ${
                          verifyPassword.length > 0 && password !== verifyPassword 
                            ? 'border-red-300 bg-red-50' 
                            : 'border-gray-200'
                        }`}
                        placeholder="Gentag din adgangskode"
                      />
                      {verifyPassword.length > 0 && password !== verifyPassword && (
                        <p className="text-xs text-red-500 flex items-center mt-1">
                          <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                          </svg>
                          Adgangskoderne matcher ikke
                        </p>
                      )}
                    </div>
                  )}
                  
                  {pwError && (
                    <div className="bg-red-50 border border-red-200 rounded-xl p-4">
                      <div className="flex">
                        <svg className="w-5 h-5 text-red-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                        </svg>
                        <p className="text-sm text-red-700">{pwError}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* User Status Card */}
              {IsAuth(['Admin', 'Event_admin']) && (
                <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
                  <div className="px-8 py-6 border-b border-gray-100">
                    <h2 className="text-xl font-semibold text-gray-900 flex items-center">
                      <svg className="w-5 h-5 mr-2 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      Brugerstatus
                    </h2>
                    <p className="text-gray-500 text-sm mt-1">Administrer brugerens adgang</p>
                  </div>
                  <div className="px-8 py-6">
                    <div className="flex items-center justify-between">
                      <div>
                        <h3 className="text-sm font-semibold text-gray-900">Brugeraktivitet</h3>
                        <p className="text-sm text-gray-500">Aktiver eller deaktiver brugerens adgang til systemet</p>
                      </div>
                      <div className="flex items-center">
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            id="changeActive"
                            name="changeActive"
                            type="checkbox"
                            checked={isActive}
                            onChange={(e) => setIsActive(e.target.checked)}
                            className="sr-only peer"
                          />
                          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600"></div>
                        </label>
                        <span className={`ml-3 text-sm font-medium ${
                          isActive ? 'text-green-600' : 'text-gray-500'
                        }`}>
                          {isActive ? 'Aktiv' : 'Deaktiveret'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Roles Card */}
              {allRoles && allRoles.length > 0 && (
                <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
                  <div className="px-8 py-6 border-b border-gray-100">
                    <h2 className="text-xl font-semibold text-gray-900 flex items-center">
                      <svg className="w-5 h-5 mr-2 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                      Brugerroller
                    </h2>
                    <p className="text-gray-500 text-sm mt-1">Administrer brugerens roller og tilladelser</p>
                  </div>
                  <div className="px-8 py-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {allRoles.map((role, roleIdx) => (
                        <div key={roleIdx} className="flex items-center justify-between p-4 bg-gray-50 rounded-xl border border-gray-200">
                          <div className="flex items-center">
                            <div className="w-2 h-2 bg-indigo-500 rounded-full mr-3"></div>
                            <span className="text-sm font-medium text-gray-700">{role}</span>
                          </div>
                          <label className="relative inline-flex items-center cursor-pointer">
                            <input
                              id={`role-${role}`}
                              name={`role-${role}`}
                              value={role}
                              onChange={(e) => setRoles(role, e.target.checked)}
                              type="checkbox"
                              className="sr-only peer"
                              checked={editData?.roles?.find(roles => role?.includes(roles)) ? true : false}
                            />
                            <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-indigo-600"></div>
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
  
              {/* Action Buttons */}
              <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
                <div className="px-8 py-6">
                  <div className="flex flex-col sm:flex-row gap-4 justify-end">
                    <button
                      type="button"
                      onClick={() => navigate(-1)}
                      className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 rounded-xl text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-200 shadow-sm hover:shadow-md"
                    >
                      <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                      Annuller
                    </button>
                    <button
                      type="submit"
                      disabled={isSaving}
                      aria-busy={isSaving}
                      className={`inline-flex items-center justify-center px-8 py-3 border border-transparent rounded-xl text-sm font-semibold text-white shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-200 ${
                        isSaving 
                          ? 'bg-indigo-400 cursor-not-allowed shadow-md' 
                          : 'bg-primary-blue hover:from-indigo-700 hover:to-purple-700 hover:shadow-xl transform hover:-translate-y-0.5'
                      }`}
                    >
                      {isSaving ? (
                        <>
                          <svg className="animate-spin -ml-1 mr-3 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                          Gemmer...
                        </>
                      ) : (
                        <>
                          <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                          Gem ændringer
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </>
      : <LoadingSpinner />}
    </>
    )
  }